import gql from "graphql-tag";

export default gql`
  query getSellerReviews($sellerId: Int!) {
    allSellerReviews(condition: { sellerId: $sellerId }) {
      nodes {
        id
        sellerId
        buyerId
        listingId
        rating
        reviewText
        transactionCompleted
        createdAt
        listing: carsForSaleByListingId {
          id
          year
          make
          model
          trim
        }
      }
    }
  }
`;
